module.exports = __webpack_public_path__ + "static/media/img-2.efa3fa42.jpg";